import React, { PropsWithChildren } from 'react';
import { HomeMenuCardWrapper } from './HomeMenuCardStyles';

interface IProps {
  cardClassName?: string;
  backgroundImage: string;
  onClickCallback?: () => void;
  height: string;
  disabled?: boolean;
  width: string;
  style?: React.CSSProperties;
}

export const HomeMenuCard: React.FC<PropsWithChildren<IProps>> = (props) => {
  const { cardClassName, backgroundImage, onClickCallback, height, children, disabled, width, ...rest } = props;

  return (
    <HomeMenuCardWrapper
      {...rest}
      className={`${cardClassName && ` ${cardClassName}`}${disabled ? ' disabled' : ''}`}
      onClick={disabled ? undefined : onClickCallback}
      backgroundImage={`url(${backgroundImage})`}
      height={height}
      width={width}
    >
      {children}
    </HomeMenuCardWrapper>
  );
};
